/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BilletOrderUrlResponseViewModel } from "../types/BilletOrderUrlResponseViewModel.ts";

export const billetOrderUrlResponseViewModelSchema = z.object({
  defaultUrl: z.string().nullish(),
  png: z.string().nullish(),
  pdf: z.string().nullish(),
  boletoHibrido: z.string().nullish(),
  boletoPix: z.string().nullish(),
  barcode: z.string().nullish(),
  envelope: z.string().nullish(),
  letter: z.string().nullish(),
  line: z.string().nullish(),
  recibo: z.string().nullish(),
}) as unknown as ToZod<BilletOrderUrlResponseViewModel>;
